import { render, staticRenderFns } from "./MediaCoverageDetail.vue?vue&type=template&id=45f8ce48&scoped=true&"
import script from "./MediaCoverageDetail.vue?vue&type=script&lang=js&"
export * from "./MediaCoverageDetail.vue?vue&type=script&lang=js&"
import style0 from "./MediaCoverageDetail.vue?vue&type=style&index=0&id=45f8ce48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8ce48",
  null
  
)

export default component.exports